import React from "react";

import ReactFreezeframe from "react-freezeframe";
import photographers from "../data/photographers.json";
import film from "../data/film.json";
import Header from "./Header";
import Footer from "./Footer";

const artistsJson = {
  photography: photographers,
  film: film,
};

class ArtistsDetail extends React.Component {
  render() {
    let findArtist = artistsJson[this.props.match.params.type].filter(
      (item) => {
        return item.id == this.props.match.params.id;
      }
    );
    let artistDetails = findArtist[0];
    let recentWorkThumbs = [];
    let extraThumbs = [];
    if (artistDetails.recentWorkThumbs) {
      recentWorkThumbs = artistDetails.recentWorkThumbs.map((item) => {
        return (
          <a
            target="_blank"
            href={`${item.url}`}
            className="artists-thumb"
            key={item.name}
          >
            <div className="artists-thumb-image">
              {this.props.match.params.type === "film" ? (
                <ReactFreezeframe
                  src={`${process.env.PUBLIC_URL}${item.image}`}
                />
              ) : (
                <img
                  src={`${process.env.PUBLIC_URL}${item.image}`}
                  alt={item.name}
                />
              )}
            </div>
            <div className="artists-thumb-text">
              <h3>{item.name}</h3>
            </div>
          </a>
        );
      });
    }
    if (artistDetails.extraThumbs) {
      extraThumbs = artistDetails.extraThumbs.map((item) => {
        return (
          <a
            target="_blank"
            href={`${item.url}`}
            className="artists-thumb"
            key={item.name}
          >
            <div className="artists-thumb-image">
              {this.props.match.params.type === "film" ? (
                <ReactFreezeframe
                  src={`${process.env.PUBLIC_URL}${item.image}`}
                />
              ) : (
                <img
                  src={`${process.env.PUBLIC_URL}${item.image}`}
                  alt={item.name}
                />
              )}
            </div>
            <div className="artists-thumb-text">
              <h3>{item.name}</h3>
            </div>
          </a>
        );
      });
    }
    return (
      <div>
        <Header />

        <div className="container artist-detail">
          <h1 className="heading serif-font">
            {artistDetails.name} &mdash;{" "}
            <span className="serif-italic-font">{artistDetails.title}</span>
          </h1>

          {artistDetails.recentWorkThumbs.length ? (
            <div>
              <h2>Recent Work</h2>
              <div
                className={`artists-thumbs detail-thumbs ${this.props.match.params.type}-thumbs`}
              >
                {recentWorkThumbs}
              </div>
            </div>
          ) : (
            ""
          )}
          {artistDetails.extraThumbsTitle ? (
            <div>
              <h2>{artistDetails.extraThumbsTitle}</h2>
              <div
                className={`artists-thumbs detail-thumbs ${this.props.match.params.type}-thumbs`}
              >
                {extraThumbs}
              </div>
            </div>
          ) : (
            ""
          )}
          {artistDetails.recentWorkThumbs.length ? (
            <h2>View More Work:</h2>
          ) : (
            ""
          )}
          <p>
            <a href={`http://${artistDetails.website}`} target="_blank">
              {artistDetails.website}
            </a>
          </p>
          <p style={{ margin: "0 6px 0 6px" }}>|</p>
          <p>
            <a
              target="_blank"
              href={`http://www.instagram.com/${artistDetails.instagram}`}
            >
              @{artistDetails.instagram}
            </a>
          </p>

          <h2>Bio:</h2>
          <p className="artist-biography">{artistDetails.biography}</p>
          {artistDetails.bioPhoto ? (
            <div className="artist-bio-photo">
              <img
                src={artistDetails.bioPhoto}
                alt={`Photo of ${artistDetails.name}`}
              />
            </div>
          ) : (
            ""
          )}
        </div>
        <Footer />
      </div>
    );
  }
}

export default ArtistsDetail;
